import Vue from 'vue'
import VueRouter from 'vue-router'

import Login from '@/components/sections/auth/Login'
import ResetPasswordReq from '@/components/sections/auth/ResetPasswordReq'
import UpdatePassword from '@/components/sections/auth/UpdatePassword'
import ReservationsIndex from '@/components/sections/reservations/Index'
import UsersIndex from '@/components/sections/users/Index'
import ProfileIndex from '@/components/sections/profile/Index'
import Rates from '@/components/sections/rates/Index'
import Design from '@/components/sections/design/Index'
import Settings from '@/components/sections/settings/Index'
import AccessDenied from '@/components/helpers/AccessDenied'
import VerifyEmail from '@/components/sections/users/VerifyEmail'
// import store from '../store'

Vue.use(VueRouter)
const routes = [
	{path: '/', 			component: ReservationsIndex},
	{name: 'Login', 		component: Login, path: '/login'},
	{name: 'ResetPasswd', 	component: ResetPasswordReq, path: '/reset-passwd',},
	{name: 'UpdatePasswd', 	component: UpdatePassword, path: '/update-passwd'},
	{path: '/reservations', component: ReservationsIndex},
	{path: '/users', 		component: UsersIndex},
	{path: '/profile', 		component: ProfileIndex},
	{path: '/rates', 		component: Rates},
	{path: '/design', 		component: Design},
	{path: '/settings', 	component: Settings},
	{path: '/denied', 		component: AccessDenied},
	{path: '/verify-email', component: VerifyEmail},
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return {x: 0, y: 0}
		}
	},
})

router.beforeEach((to, from, next) => {
	let currentUser = localStorage.getItem("user");
	currentUser = currentUser ? JSON.parse(currentUser) : null;

	if (['Login', 'ResetPasswd', 'UpdatePasswd'].indexOf(to.name) === -1 && currentUser === null) {
		next({name: 'Login'})
	} else next()
})

export default router
